import React, { Component } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/footer.component";
import Header from "../../components/header.component";
import "../../css/error-page.css";
import reportVisitService from "../../reporting-visit/report-visit.service";

export default class ServiceUnavailable extends Component {
  componentDidMount() {
    document.title =
      "Service unavailable | David Šimák - A self-taught JAVA/Kotlin developer";
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    return (
      <div>
        <Header customColor="#424242" lightColor={true} />

        <div class="error-overview">
          <div className="error-overview-title-container">
            <label className="error-overview-title">Service unavaible</label>
          </div>
          <h2>
            I am very sorry but it's looks like that the service is currently
            unavaible
          </h2>
          <h3>Please, try again later</h3>
          <h4>
            In the meantime you can learn something{" "}
            <Link
              className="text-bold-background"
              to="https://www.davidsimak.dev/about"
            >
              about me
            </Link>
            <br />
            or explore{" "}
            <Link
              className="text-bold-background"
              to="https://www.davidsimak.dev/projects"
            >
              some of my projects
            </Link>
          </h4>
        </div>

        <Footer />
      </div>
    );
  }
}
